import type {AutoDeliveryDcxUpdateReasonStatus} from '@/consts/icc/iccAutoDeliveryStatusTypes';
import type {AutoDeliveryInfoBoxSource} from '@/types/content';
import {AUTO_DELIVERY_INFO_BOX_SOURCES} from '@/types/content';
import {AutoDeliveryDcxInfoBox} from '@/views/AutoDeliveryDcx/AutoDeliveryDcxInfoBox';

import {getOnHoldInfoBoxData} from './autoDeliveryDcxOnHold.helpers';

type AutoDeliveryDcxOnHoldInfoBoxProps = {
    statusUpdateReason: AutoDeliveryDcxUpdateReasonStatus | null;
    className?: string;
    source?: AutoDeliveryInfoBoxSource;
};

const AutoDeliveryDcxOnHoldInfoBox = ({
    statusUpdateReason,
    className,
    source = AUTO_DELIVERY_INFO_BOX_SOURCES.DETAILS,
}: AutoDeliveryDcxOnHoldInfoBoxProps) => {
    const notificationResult = getOnHoldInfoBoxData(statusUpdateReason, source);

    if (!notificationResult) return null;

    return <AutoDeliveryDcxInfoBox data={notificationResult} className={className} source={source} />;
};

export default AutoDeliveryDcxOnHoldInfoBox;
